import { render } from "./CustomError403.vue?vue&type=template&id=3efbadcc"
import script from "./CustomError403.vue?vue&type=script&lang=js"
export * from "./CustomError403.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/web/driving-school-be/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"CustomError403.vue"]])

export default __exports__